<p>{{ 'Authenticating' | translate }}...</p>
